import NavItem from 'Components/NavBar/NavItem';
import { CalendarDaysIcon } from 'lucide-preact';

/**
 * Generates a function comment for the given function body.
 *
 * @param {Object} props - The props object containing the function's parameters.
 * @param {boolean} [props.avoidInnerPadding] - Removes the padding on the inner element.
 * @param {function} [props.onClick] - The function to be called when the item is clicked.
 * @param {string} [props.target] - The target for the talk navigation item.
 * @param {string} [props.className] - The class name for the talk navigation item.
 * @return {import('preact/compat').ReactElement} The JSX element representing the TalkNavItem component.
 */
const TalkNavItem = ({ onClick, target, avoidInnerPadding, className }) => {
  return (
    <NavItem
      avoidInnerPadding={avoidInnerPadding}
      text="Events"
      url="/schedule"
      customIcon={<CalendarDaysIcon className="size-5" />}
      onClick={onClick}
      target={target}
      data-tour="live-events-button"
      className={className}
    />
  );
};

export default TalkNavItem;
